"use client";

import { findManagedSeller, useRequireMember } from "./session";
import type { ManagedSeller } from "./types";

/*
 * 판매처 영역에 들어갈 수 있는가.
 *
 * 🔴 **여기서 막는 것은 «보이지 않게» 하는 것뿐입니다.** 진짜 판정은 서버가
 *    라우트마다 `seller_managers` 를 보고 합니다 (`docs/base/10` §2-4 ·
 *    `EnsureSellerManager`). 화면의 검사는 잘못 들어온 사람에게 404 대신
 *    사람 말로 알려 주기 위한 것이지, 보안 장치가 아닙니다.
 *
 * 🔴 **총판 전용 동작**(가맹점 생성·요율 변경)은 `kind === "distributor"` 로 가릅니다.
 *    서버도 `seller.manager:distributor` 로 같은 자리를 막습니다.
 */
export type SellerAccess =
  | { state: "loading"; seller: null; sellerId: number }
  | { state: "denied"; seller: null; sellerId: number }
  | { state: "ok"; seller: ManagedSeller; sellerId: number };

export function useManagedSeller(rawId: string): SellerAccess {
  const session = useRequireMember();
  const sellerId = Number(rawId);

  if (session.status !== "member") {
    return { state: "loading", seller: null, sellerId };
  }

  /* 🔑 `Number("abc")` 는 NaN 입니다 — 주소를 손으로 고친 경우에도 막힙니다. */
  if (!Number.isFinite(sellerId)) {
    return { state: "denied", seller: null, sellerId };
  }

  const seller = findManagedSeller(session.user, sellerId);
  if (!seller) return { state: "denied", seller: null, sellerId };

  return { state: "ok", seller, sellerId };
}
